export var EOrderBookOrderBy;
(function (EOrderBookOrderBy) {
    EOrderBookOrderBy["Amount"] = "amount";
    EOrderBookOrderBy["TRXDATE"] = "trx_date";
})(EOrderBookOrderBy || (EOrderBookOrderBy = {}));
export var EProductBouquetOrderBy;
(function (EProductBouquetOrderBy) {
    EProductBouquetOrderBy["PriceRange"] = "price_range";
})(EProductBouquetOrderBy || (EProductBouquetOrderBy = {}));
export var EBuySell;
(function (EBuySell) {
    EBuySell["Buy"] = "Buy";
    EBuySell["Sell"] = "Sell";
})(EBuySell || (EBuySell = {}));
export var StatusCode;
(function (StatusCode) {
    StatusCode[StatusCode["OK"] = 200] = "OK";
    StatusCode[StatusCode["CREATED"] = 201] = "CREATED";
    StatusCode[StatusCode["ACCEPTED"] = 202] = "ACCEPTED";
    StatusCode[StatusCode["NO_CONTENT"] = 204] = "NO_CONTENT";
    StatusCode[StatusCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["NOT_FOUND"] = 404] = "NOT_FOUND";
    StatusCode[StatusCode["CONFLICT"] = 409] = "CONFLICT";
    StatusCode[StatusCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    StatusCode[StatusCode["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
})(StatusCode || (StatusCode = {}));
export var EOrderBookOtcStatus;
(function (EOrderBookOtcStatus) {
    EOrderBookOtcStatus["PSM_PENDING"] = "PSM Pending";
    EOrderBookOtcStatus["PSM_REJECTED"] = "PSM Rejected";
    EOrderBookOtcStatus["PSM_AUTO_REJECTED"] = "PSM Auto Rejected";
    EOrderBookOtcStatus["CLIENT_CONSENT_PENDING"] = "Client Consent Pending";
    EOrderBookOtcStatus["CLIENT_CONSENT_REJECTED"] = "Client Consent Rejected";
    EOrderBookOtcStatus["CLIENT_CONSENT_AUTO_REJECTED"] = "Client Consent Auto Rejected";
    EOrderBookOtcStatus["PAYMENT_PENDING"] = "Payment Pending";
    EOrderBookOtcStatus["PAYMENT_REJECTED"] = "Payment Rejected";
    EOrderBookOtcStatus["PAYMENT_AUTO_REJECTED"] = "Payment Auto Rejected";
    EOrderBookOtcStatus["STOCK_PENDING"] = "Stock Pending";
    EOrderBookOtcStatus["STOCK_REJECTED"] = "Stock Rejected";
    EOrderBookOtcStatus["STOCK_AUTO_REJECTED"] = "Stock Auto Rejected";
    EOrderBookOtcStatus["ORDER_COMPLETED"] = "Order Completed";
    EOrderBookOtcStatus["ORDER_PENDING"] = "Order Pending";
    EOrderBookOtcStatus["ORDER_REJECTED"] = "Order Rejected";
    EOrderBookOtcStatus["ORDER_AUTO_REJECTED"] = "Order Auto Rejected";
    EOrderBookOtcStatus["REFUND_PENDING"] = "Refund Pending";
    EOrderBookOtcStatus["REFUND_REJECTED"] = "Refund Rejected";
    EOrderBookOtcStatus["REFUND_COMPLETED"] = "Refund Completed";
})(EOrderBookOtcStatus || (EOrderBookOtcStatus = {}));
export var EKebebMenuItemsOTC;
(function (EKebebMenuItemsOTC) {
    EKebebMenuItemsOTC["INITIATE_REFUND"] = "Initiate Refund";
    EKebebMenuItemsOTC["VIEW_DETAILS"] = "View Details";
    EKebebMenuItemsOTC["CANCEL"] = "Cancel";
})(EKebebMenuItemsOTC || (EKebebMenuItemsOTC = {}));
export var EFieldName;
(function (EFieldName) {
    EFieldName["Rating"] = "rating";
    EFieldName["InterestFrequency"] = "interestfrequency";
    EFieldName["MaturityDate"] = "maturitydate";
    EFieldName["IssuerName"] = "issuername";
    EFieldName["PriceRange"] = "pricerange";
    EFieldName["IsSecured"] = "issecured";
    EFieldName["Coupon"] = "coupon";
    EFieldName["MinInvestment"] = "mininvestment";
    EFieldName["AvailableQuantity"] = "avlqty";
})(EFieldName || (EFieldName = {}));
export var EOrderbookFilters;
(function (EOrderbookFilters) {
    EOrderbookFilters["InvestmentValue"] = "investmentvalue";
    EOrderbookFilters["Status"] = "status";
    EOrderbookFilters["ProductType"] = "product_type";
    EOrderbookFilters["ClientName"] = "client_name";
})(EOrderbookFilters || (EOrderbookFilters = {}));
export var EOrderbookProductId;
(function (EOrderbookProductId) {
    EOrderbookProductId["InvestmentValue"] = "investmentvalue";
    EOrderbookProductId["Status"] = "status";
    EOrderbookProductId["ProductType"] = "product_type";
    EOrderbookProductId["ClientName"] = "client_name";
})(EOrderbookProductId || (EOrderbookProductId = {}));
export var EOrderbookFilterTabs;
(function (EOrderbookFilterTabs) {
    EOrderbookFilterTabs["Rating"] = "Rating";
    EOrderbookFilterTabs["Type"] = "Type";
    EOrderbookFilterTabs["PriceRange"] = "Price Range";
    EOrderbookFilterTabs["Price"] = "Price (\u20B9)";
    EOrderbookFilterTabs["PayoutFreq"] = "Payout Freq.";
    EOrderbookFilterTabs["MaturityDate"] = "Maturity Date";
    EOrderbookFilterTabs["IssuerName"] = "Issuer Name";
    EOrderbookFilterTabs["CouponFreq"] = "Coupon Freq.";
    EOrderbookFilterTabs["MinInvestment"] = "Min Investment";
    EOrderbookFilterTabs["AvailableQuantity"] = "Available Quantity";
    EOrderbookFilterTabs["ProductType"] = "Product Type";
    EOrderbookFilterTabs["Status"] = "Status";
    EOrderbookFilterTabs["ClientName"] = "Client Name";
    EOrderbookFilterTabs["InvestmentValue"] = "Investment Value";
})(EOrderbookFilterTabs || (EOrderbookFilterTabs = {}));
export var ERefundType;
(function (ERefundType) {
    ERefundType[ERefundType["ExcessFunds"] = 6] = "ExcessFunds";
    ERefundType[ERefundType["InterestDividend"] = 7] = "InterestDividend";
    ERefundType[ERefundType["CancelledRejected"] = 9] = "CancelledRejected";
    ERefundType[ERefundType["Suspense"] = 10] = "Suspense";
})(ERefundType || (ERefundType = {}));
export var ERefundNameType;
(function (ERefundNameType) {
    ERefundNameType["ExcessFunds"] = "Excess Funds";
    ERefundNameType["Dividend"] = "Dividend";
    ERefundNameType["Interest"] = "Interest";
    ERefundNameType["CancelledRejected"] = "Cancelled/Rejected";
    ERefundNameType["Suspense"] = "Suspense";
})(ERefundNameType || (ERefundNameType = {}));
export var ETimelineState;
(function (ETimelineState) {
    ETimelineState["COMPLETED"] = "completed";
    ETimelineState["IN_PROGRESS"] = "inprogress";
    ETimelineState["REJECTED"] = "rejected";
    ETimelineState["AWAITED"] = "awaited";
    ETimelineState["BLANK"] = "";
    ETimelineState["APPROVED"] = "approved";
    ETimelineState["EXECUTED"] = "executed";
})(ETimelineState || (ETimelineState = {}));
